import { CustomIcon } from 'modules/components/layer00';
import { SavePersonForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import React from 'react';



export type SavePersonModalProps = {
  id?: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SavePersonModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id=''
      title='Update Profile'
      subTitle='Update your information'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
      headerIcon={<CustomIcon.large.FC icon='CREATOR' />}
    >
      <SavePersonForm.FC
        id=''
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );
};
